<template>
  <div>
    <a-transfer
      :data-source="!data? [] : data"
      :target-keys="!authed? [] : authed"
      :show-search="showSearch"
      :filter-option="filterOption"
      :show-select-all="showSelectAll"
      @change="onChange"
      :list-style="listStyle"
      :titles="titles"
    >
      <template
        slot="children"
        slot-scope="{
          props: { direction, filteredItems, selectedKeys, disabled: listDisabled },
          on: { itemSelectAll, itemSelect },
        }"
      >
        <a-table
        :loading="loading"
          :row-selection="
            getRowSelection({ disabled: listDisabled, selectedKeys, itemSelectAll, itemSelect })
          "
          :scroll="{ y: 320, x: 0 }"
          :pagination="false"
          :columns="direction === 'left' ? leftColumns : rightColumns"
          :data-source="filteredItems? filteredItems : []"
          size="small"
          :style="{ pointerEvents: listDisabled ? 'none' : null }"
          :custom-row="
            ({ key, disabled: itemDisabled }) => ({
              on: {
                click: () => {
                  if (itemDisabled || listDisabled) return;
                  itemSelect(key, !selectedKeys.includes(key));
                },
              },
            })
          "
        />
      </template>
      <template
        slot="footer"
        size="small">
        <a-row type="flex">
          <a-col flex="auto">
            <!-- <a-spin v-if="loading" style="float:right;margin: 5px" /> -->
            <a-button
              v-if="!loading"
              style="float:right;margin: 5px"
              @click="$emit('reload')"
            >
              Reload
            </a-button>
          </a-col>
        </a-row>
      </template>
    </a-transfer>
  </div>
</template>
<script>
import difference from "lodash/difference"

export default {
  name: "transfer-selection",
  props: {
    data: { type: Array, required: true },
    loading: Boolean,
    authed: { type: Array, required: true },
    titles: Array,
    leftColumns: Object,
    rightColumns: Object,
    showSearch: Boolean,
    filterOption: Function,
    showSelectAll: Boolean,
    listStyle: Object,
  }, // ["data", "loading", "authed", "titles", "leftColumns", "rightColumns"],
  data() {
    return {
    }
  },
  methods: {
    onChange(nextTargetKeys) {
      this.$emit("change", nextTargetKeys)
    },
    getRowSelection({ disabled, selectedKeys, itemSelectAll, itemSelect }) {
      return {
        getCheckboxProps: item => ({ props: { disabled: disabled || item.disabled } }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows
            .filter(item => !item.disabled)
            .map(({ key }) => key)
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys)
          itemSelectAll(diffKeys, selected)
        },
        onSelect({ key }, selected) {
          itemSelect(key, selected)
        },
        selectedRowKeys: selectedKeys,
      }
    },
  },
}
</script>
<style lang="less">

.ant-table-fixed-header .ant-table-content .ant-table-scroll .ant-table-body{
  background: unset !important;
}
.ant-table-header.ant-table-hide-scrollbar{
  margin-bottom: 0px !important;
  overflow: auto !important;
}
</style>
